import { MantineTheme, createStyles } from "@mantine/styles";

export const useStyles = createStyles((theme: MantineTheme) => ({
  parentContainer: {
    paddingTop: "130px",
    display: "flex",
    justifyContent: "center",
    width: "100vw",
    height: "100vh",
    alignItems: "flex-start",
    boxSizing: "border-box",
    overflowY: "auto",
    [theme.fn.smallerThan("sm")]: {
      flexDirection: "column",
      justifyContent: "flex-start",
    },
  },
  container: {
    width: "80%",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    padding: "8px",
    paddingBottom: 0,
    boxSizing: "border-box",
    [theme.fn.smallerThan("sm")]: {
      width: "100%",
      padding: "20px",
    },
  },
  headingContainer: {
    color: "#151515",
    fontSize: "30px",
    fontWeight: 750,
    lineHeight: "normal",
    letterSpacing: "0em",
    fontStyle: "normal",
    [theme.fn.smallerThan("sm")]: {
      width: "100%",
      height: "auto",
      marginLeft: "0",
      marginRight: "0",
      fontSize: "20px",
    },
  },
  secondheadingContainer: {
    color: "#151515",
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "normal",
    letterSpacing: "0em",
    fontStyle: "normal",
    [theme.fn.smallerThan("sm")]: {
      width: "100%",
      height: "auto",
      marginLeft: "0",
      marginRight: "0",
      fontSize: "20px",
    },
  },
  line: {
    margin: "1px",
  },
  buttonGroup: {
    textAlign: "center",
    borderRadius: "10px",
    [theme.fn.smallerThan("sm")]: {},
  },
  btn: {
    fontSize: "18px",
    padding: "1rem 4rem",
    cursor: "pointer",
    [theme.fn.smallerThan("sm")]: {
      fontSize: "16px",
      fontWeight: 700,
    },
  },
  subtext: {
    fontSize: "13px",
    marginTop: "10px",
  },
  subHeading: {
    marginTop: "20px",
    left: "68px",
    fontSize: "17px",
    fontWeight: 600,
    lineHeight: "16.71px",
    color: "#000000",
  },
  instructionHeading: {
    marginTop: "20px",
    left: "68px",
    fontSize: "13px",
    fontWeight: 400,
    lineHeight: "16.71px",
    color: "#000000",
  },
  instructionHeadingItalic: {
    fontSize: "12px",
    color: "#000000",
    fontStyle: "italic",
  },
  otpWrapper: {
    width: "395px",
    height: "67px",
    display: "flex",
    flexDirection: "row",
    marginTop: "10px",
    left: "65px",
    justifyContent: "center",
  },
  otpDigit: {
    width: "41px",
    height: "36px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    backgroundColor: "#D9D9D9",
    margin: "5px",
    fontSize: "14px",
    border: 0,
  },
  photoDisplay: {
    width: "30%",
    display: "block",
    marginTop: "15px",
    marginBottom: "15px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  photoDisplayQR: {
    width: "35%",
    display: "block",
    marginTop: "15px",
    marginBottom: "15px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  ulList: {
    fontSize: "12px",
  },
  modalTitle: {
    fontWeight: 500,
    fontSize: "16px",
    padding: "7px",
  },
  modalHeader: {
    backgroundColor: "#ebeceb",
  },
  photoDisplay2FA: {
    width: "25%",
    display: "block",
    marginTop: "25px",
    marginBottom: "10px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  instructionHeadingNoMargin: {
    fontSize: "13px",
    lineHeight: "16.71px",
    color: "#000000",
    padding: "0px",
    margin: "0px",
  },
}));
